import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-plangruppe-list-view',
  imports: [],
  templateUrl: './plangruppe.list-view.html',
  styleUrls: ['./plangruppe.list-view.css'],
})
export class PlangruppeListView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
